import React, { createContext, useContext, useState, useCallback, useEffect } from "react";
import { translations, LANGS } from "./translations";
import { ui } from "./uiText";

const LanguageContext = createContext(null);
const STORAGE_KEY = "supera_lang";
const RTL_LANGS = ["AR"];
const isValid = (code) => LANGS.some((l) => l.code === code);

export function LanguageProvider({ children }) {
  const [lang, setLangState] = useState(() => {
    const saved = typeof localStorage !== "undefined" ? localStorage.getItem(STORAGE_KEY) : null;
    return saved && isValid(saved) ? saved : "ES";
  });

  useEffect(() => {
    if (typeof document === "undefined") return;
    document.documentElement.lang = lang.toLowerCase();
    document.documentElement.dir = RTL_LANGS.includes(lang) ? "rtl" : "ltr";
  }, [lang]);

  const setLang = useCallback((code) => {
    if (!isValid(code)) return;
    setLangState(code);
    try { localStorage.setItem(STORAGE_KEY, code); } catch {}
    if (typeof document !== "undefined") {
      document.documentElement.lang = code.toLowerCase();
      document.documentElement.dir = RTL_LANGS.includes(code) ? "rtl" : "ltr";
    }
  }, []);

  // The DOM auto-translator handles ALL languages uniformly from the Spanish base,
  // so we always expose the ES dictionaries to avoid double-translation.
  const t = translations.ES;
  const u = ui.ES;

  return (
    <LanguageContext.Provider value={{ lang, setLang, t, u, langs: LANGS, isRTL: RTL_LANGS.includes(lang) }}>
      {children}
    </LanguageContext.Provider>
  );
}

export function useLang() {
  const ctx = useContext(LanguageContext);
  if (!ctx) throw new Error("useLang must be used within LanguageProvider");
  return ctx;
}
